import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/socialnewbs/socialnewbs.com/frontend/releases/20251215124819/components/Analytics.tsx");
;
import(/* webpackMode: "eager" */ "/home/socialnewbs/socialnewbs.com/frontend/releases/20251215124819/components/core/ResponsiveImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/socialnewbs/socialnewbs.com/frontend/releases/20251215124819/components/core/SubscriptionForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/socialnewbs/socialnewbs.com/frontend/releases/20251215124819/components/layouts/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/socialnewbs/socialnewbs.com/frontend/releases/20251215124819/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/home/socialnewbs/socialnewbs.com/frontend/shared/node_modules/next/dist/client/link.js");
